// removed by extract-text-webpack-plugin
module.exports = {"list":"ju_ce _3JIEYde9anI6O5H5wYv2ik","listItem":"ju_ff","buttons":"ju_jv","arrowBtn":"ju_gw _1kB_d9laDuyaX1azPOvneD","arrowBtnDisabled":"ju_gz ju_gw _1kB_d9laDuyaX1azPOvneD","arrow":"ju_g0"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/ReviewList/styles.module.css
// module id = 1306
// module chunks = 27